<script lang="ts">
  import { ChevronLeft, CornerDownRight } from "lucide-svelte";

  import { formatDate } from "$lib/time";
  import ExampleLink from "$lib/ui/docs/ExampleLink.svelte";
  import type { PageData } from "./$types";

  export let data: PageData;

  $: frontmatter = data.frontmatter;
  $: authors = frontmatter.authors || [];
</script>

<svelte:head>
  <link rel="canonical" href={data.canonicalUrl} />
</svelte:head>

<div class="w-screen max-w-screen-lg mt-16 lg:mt-20 mb-32 px-4 mx-auto">
  <article class="max-w-[800px] mx-auto">
    <!-- Back button, above the metadata line on mobile screens -->
    <div class="mb-6 lg:hidden">
      <a href="/blog" class="btn btn-sm inline-flex items-center gap-x-1">
        <CornerDownRight class="text-c-gray-30 -ml-1" size={16} />
        <span class="text-c-gray-60">All posts</span>
      </a>
    </div>

    <!-- Introduction -->
    <div
      class="relative flex justify-start gap-x-4 text-sm text-c-gray-60 items-center"
    >
      <!-- Back button -->
      <a
        href={frontmatter.category === "Model Library"
          ? "/library"
          : frontmatter.category === "Article"
            ? "/articles"
            : "/blog"}
        class="btn btn-sm hidden lg:flex absolute -left-24 items-center gap-x-1"
      >
        <ChevronLeft class="text-c-gray-30 -ml-1" size={16} />
        <span class="text-c-gray-60">Back</span>
      </a>
      <div
        class="ml-0.5 hidden sm:block border rounded-full px-2.5 py-0.5 text-white border-light-green/30"
      >
        {frontmatter.category}
      </div>
      <div class="flex gap-x-2">
        <span>{formatDate(frontmatter.date)}</span><span>•</span><span
          >{frontmatter.length}</span
        >
      </div>
    </div>

    <h1 class="marketing-h3 my-8 text-white">{frontmatter.title}</h1>

    {#if (authors.length && authors[0].avatarUrl) || frontmatter.githubLink}
      <div class="flex flex-wrap gap-4 items-start justify-between">
        <div
          class="flex flex-wrap flex-col sm:flex-row gap-6 sm:gap-x-8 sm:gap-y-4"
        >
          {#each authors as author}
            {#if author.avatarUrl}
              <div class="flex items-center">
                <img
                  class="rounded-full object-cover border border-c-gray-10 w-11 h-11"
                  src={author.avatarUrl}
                  alt="author"
                />
                <div class="ml-3">
                  {#if author.twitterHandle}
                    <a
                      href="https://twitter.com/{author.twitterHandle}"
                      target="_blank"
                      rel="noreferrer"
                      class="space-x-2"
                    >
                      <span class="font-bold text-c-gray-80 whitespace-nowrap"
                        >{author.name}</span
                      ><span class="text-c-gray-60"
                        >@{author.twitterHandle}</span
                      >
                    </a>
                  {:else}
                    <span class="font-bold text-c-gray-80">{author.name}</span>
                  {/if}
                  <div class="text-c-gray-60">
                    {author.jobTitle}
                  </div>
                </div>
              </div>
            {/if}
          {/each}
        </div>
        {#if frontmatter.githubLink}
          <ExampleLink scriptPath={frontmatter.githubLink} />
        {/if}
      </div>
    {/if}

    <!-- Image -->
    <!-- <img
      src={frontmatter.image}
      alt="Blog post cover"
      class="w-full mx-auto mt-8 mb-12"
    /> -->

    <!-- Markdown content -->
    <div class="mt-12">
      <svelte:component this={data.content} />
    </div>
  </article>
</div>
